export const WarehouseEndPoints = {
  getWarehouseItems: {
    url: (company) => `/rest/v1/getWarehouseItems/${company}`,
    method: `GET`,
  },
  getPurchaseOrderLineItemsFromProcore: {
    url: (company, projectID, purchaseOrderID) =>
      `/rest/v1/getPurchaseOrderLineItemsFromProcore/${company}/${projectID}/${purchaseOrderID}`,
    method: `GET`,
  },

  transfersToProjectInventoryHistory: {
    url: (company, projectID) =>
      `/rest/v1/transfersToProjectInventoryHistory/${company}/${projectID}`,
    method: `GET`,
  },

  getWorkBreakDownStructureCode: {
    url: (company, projectID) =>
      `/rest/v1/getWorkBreakDownStructureCode/${company}/${projectID}`,
    method: `GET`,
  },

  updatePurchaseOrderLineItemInProcore: {
    url: (company, projectID, purchaseOrderID) =>
      `/rest/v1/updatePurchaseOrderLineItemInProcore/${company}/${projectID}/${purchaseOrderID}`,
    method: `PUT`,
  },

  postPurchaseOrderLineItemToProcore: {
    url: (company, projectID, purchaseOrderID) =>
      `/rest/v1/postPurchaseOrderLineItemToProcore/${company}/${projectID}`,
    method: `POST`,
  },

  getPurchaseOrdersInKoncurent: {
    url: (company) => `/rest/v1/getPurchaseOrdersInKoncurent/${company}`,
    method: `GET`,
  },

  inventoryPageAccessLevel: {
    url: (company) => `/rest/v1/inventoryPageAccessLevel/${company}`,
    method: `GET`,
  },

  getTransferRequests: {
    url: (company) => `/rest/v1/getTransferRequests/${company}`,
    method: `GET`,
  },

  getTransferDrafts: {
    url: (company) => `/rest/v1/getTransferDrafts/${company}`,
    method: `GET`,
  },

  getInventorySettings: {
    url: (company) => `/rest/v1/getInventorySettings/${company}`,
    method: `GET`,
  },

  getProjectPurchaseOrdersFromProcore: {
    url: (company, projectID) =>
      `/rest/v1/getProjectPurchaseOrdersFromProcore/${company}/${projectID}`,
    method: `GET`,
  },

  savePurchaseOrder: {
    url: (company, projectID) =>
      `/rest/v1/savePurchaseOrder/${company}/${projectID}`,
    method: `POST`,
  },

  getInventoryPurchaseHistory: {
    url: (company, itemID) =>
      `/rest/v1/getInventoryPurchaseHistory/${company}/${itemID}`,
    method: `GET`,
  },

  inventoryItemsHistory: {
    url: (company) => `/rest/v1/inventoryItemsHistory/${company}`,
    method: `POST`,
  },

  inventoryItemsHistoryDetailed: {
    url: (company) => `/rest/v1/inventoryItemsHistoryDetailed/${company}`,
    method: `POST`,
  },

  inventoryItemsNoMovement30Days: {
    url: (company) => `/rest/v1/inventoryItemsNoMovement30Days/${company}`,
    method: `POST`,
  },

  inventoryItemsNeverMoved: {
    url: (company) => `/rest/v1/inventoryItemsNeverMoved/${company}`,
    method: `POST`,
  },

  inventoryItemsStockVsTransferDrafts: {
    url: (company) =>
      `/rest/v1/inventoryItemsStockVsTransferDrafts/${company}`,
    method: `POST`,
  },

  getReportAccessLevel: {
    url: (company, project) =>
      `/rest/v1/reportPageAccessLevel/${company}/${project}`,
    method: `GET`,
  },

  updateTransferInventoryItem: {
    url: (company, itemID) =>
      `/rest/v1/updateTransferInventoryItem/${company}/${itemID}`,
    method: `PUT`,
  },

  updateTransferDrafts: {
    url: (company) => `/rest/v1/updateTransferDrafts/${company}`,
    method: `PUT`,
  },

  approveTransferRequests: {
    url: (company) => `/rest/v1/approveTransferRequests/${company}`,
    method: `PUT`,
  },

  submitTransferDrafts: {
    url: (company) => `/rest/v1/submitTransferDrafts/${company}`,
    method: `POST`,
  },

  updateWarehouseItem: {
    url: (company, itemID) =>
      `/rest/v1/updateWarehouseItem/${company}/${itemID}`,
    method: `PUT`,
  },

  createWarehouseItem: {
    url: (company) => `/rest/v1/createWarehouseItem/${company}`,
    method: `POST`,
  },

  transferInventoryItems: {
    url: (company) => `/rest/v1/transferInventoryItems/${company}`,
    method: `POST`,
  },

  transferDraft: {
    url: (company) => `/rest/v1/transferDraft/${company}`,
    method: `POST`,
  },

  transferRequest: {
    url: (company) => `/rest/v1/transferRequest/${company}`,
    method: `POST`,
  },

  sendKoncurentPurchaseOrdersToInventory: {
    url: (company, projectID) =>
      `/rest/v1/sendKoncurentPurchaseOrdersToInventory/${company}`,
    method: `POST`,
  },

  markPurchaseOrderCompleted: {
    url: (company) => `/rest/v1/markPurchaseOrderCompleted/${company}`,
    method: `POST`,
  },

  uploadWarehouseItems: {
    url: (company) => `/rest/v1/uploadWarehouseItems/${company}`,
    method: `POST`,
  },

  postPurchaseOrderToProcore: {
    url: (company, projectID) =>
      `/rest/v1/postPurchaseOrderToProcore/${company}/${projectID}`,
    method: `POST`,
  },
  updatePurchaseOrderInProcore: {
    url: (company, projectID, purchaseOrderID) =>
      `/rest/v1/updatePurchaseOrderInProcore/${company}/${projectID}/${purchaseOrderID}`,
    method: `PUT`,
  },

  deleteWarehouseItem: {
    url: (company, itemID) =>
      `/rest/v1/deleteWarehouseItem/${company}/${itemID}`,
    method: `DELETE`,
  },

  deleteTransferDrafts: {
    url: (company, transferID) =>
      `/rest/v1/deleteTransferDrafts/${company}/${transferID}`,
    method: `DELETE`,
  },

  deleteTransferDraftsItems: {
    url: (company, transferID, transferItemID) =>
      `/rest/v1/deleteTransferDraftsItems/${company}/${transferID}/${transferItemID}`,
    method: `DELETE`,
  },

  transferHistoryInventory: {
    url: (company) => `/rest/v1/transferHistoryInventory/${company}`,
    method: `GET`,
  },

  getWarehouseOverview: {
    url: (company) => `/rest/v1/getWarehouseOverview/${company}`,
    method: `GET`,
  },

  getJobSites: {
    url: (company) => `/rest/v1/getJobSites/${company}`,
    method: `GET`,
  },
  createJobSite: {
    url: (company) => `/rest/v1/createJobSite/${company}`,
    method: `POST`,
  },
  updateJobSite: {
    url: (company, jobSiteID) =>
      `/rest/v1/updateJobSite/${company}/${jobSiteID}`,
    method: `PUT`,
  },
  deleteJobSite: {
    url: (company, jobSiteID) =>
      `/rest/v1/deleteJobSite/${company}/${jobSiteID}`,
    method: `DELETE`,
  },
  createInventorySettings: {
    url: (company) => `/rest/v1/createInventorySettings/${company}`,
    method: `POST`,
  },
  updateInventorySettings: {
    url: (company) => `/rest/v1/updateInventorySettings/${company}`,
    method: `PUT`,
  },

  deleteInventorySettings: {
    url: (company) => `/rest/v1/deleteInventorySettings/${company}`,
    method: `DELETE`,
  },
};
